import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-add-view',
  templateUrl: './user-add-view.component.html',
  styleUrls: ['./user-add-view.component.css']
})
export class UserAddViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
